import { render, staticRenderFns } from "./customerPriceListSetupDialog.vue?vue&type=template&id=12eed7b0&"
import script from "./customerPriceListSetupDialog.vue?vue&type=script&lang=js&"
export * from "./customerPriceListSetupDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports